import { useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '@burna/monster-design-system';
import classNames from 'classnames';
import useUser from 'hooks/useUser';
import logo from 'assets/logo.svg';
import styles from './index.module.scss';

function Header({ onSelectLogout }) {
  const { pathname } = useLocation();
  const user = useUser();
  const mask = `url('${logo}') 0 0 / 100% 100%`;

  const render = useCallback(() => {
    if (user.username) {
      const isFileListPath = pathname === '/fileList';
      return (
        <>
          {!isFileListPath ? (
            <>
              <Button
                as={Link}
                to="/fileList"
                hierarchy="tertiary"
                size="sm"
                text="Manage"
                icon="archive"
                className={styles.item}
              />
              |
            </>
          ) : null}
          <Button
            hierarchy="tertiary"
            size="sm"
            text="Log out"
            icon="log-out"
            className={classNames([styles.item, styles.logoutButton])}
            onClick={onSelectLogout}
          />
        </>
      );
    }
    return (
      <>
        <Button
          as={Link}
          to="/login"
          hierarchy="tertiary"
          size="sm"
          text="Login"
          icon="user"
          className={styles.item}
        />
        /
        <Button
          as={Link}
          to="/register"
          hierarchy="tertiary"
          size="sm"
          text="Register"
          className={styles.item}
        />
      </>
    );
  }, [pathname, user]);

  return (
    <header className={styles.header}>
      <section className={styles.container}>
        <Link className={styles.logoContainer} to="/">
          <div className={styles.logo} style={{ WebkitMask: mask, mask }} />
        </Link>
        <div className={styles.itemsContainer}>{render()}</div>
      </section>
    </header>
  );
}

export default Header;
